import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/trash_24.svg.ts
import { svg } from "lit";
var trash24Svg = svg`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M19.5 6V20.4375C19.5 20.9845 19.2827 21.5091 18.8959 21.8959C18.5091 22.2827 17.9845 22.5 17.4375 22.5H6.5625C6.01549 22.5 5.49089 22.2827 5.10409 21.8959C4.7173 21.5091 4.5 20.9845 4.5 20.4375V6H19.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M3 6H5H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.25 6V3.375C8.25 2.87772 8.44754 2.40081 8.79918 2.04917C9.15081 1.69754 9.62772 1.5 10.125 1.5H13.875C14.3723 1.5 14.8492 1.69754 15.2008 2.04917C15.5525 2.40081 15.75 2.87772 15.75 3.375V6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9.75 11.25V17.25" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.25 11.25V17.25" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export {
  trash24Svg
};
//# sourceMappingURL=trash_24.svg-E6QQAHPV.js.map
